export default {
    methods: {
        redirectToModulBank(url) {
            const form = document.createElement('form');

            form.method = 'POST';
            form.action = 'https://pay.modulbank.ru/pay';

            const parameters = this.parseQueryString(url)

            Object.keys(parameters).forEach(key => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = parameters[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },
        parseQueryString(url) {
            const queryString = url.split('?')[1];
            const params = new URLSearchParams(queryString);
            const result = {};

            params.forEach((value, key) => {
                result[key] = value;
            });

            return result;
        },
    },
};
